export default function AssetsRoutePage() {
  return null;
}
